import {BannerDataJson} from 'OK/banners/bannerNew/data/BannerDataJson';

export interface IBannerDataImageOptions {
    img_file: string;
    impression_urls: Array<string>;
}

export class BannerDataImage extends BannerDataJson {
    url: string | null;
    title: string;
    impressionUrls: Array<string>;

    constructor(json: IBannerDataImageOptions) {
        super(json);
        const url = (json.img_file || '').trim();
        this.url = url ? url : null;
        this.title = BannerDataJson.getStringNotNull(json, BannerDataJson.INTERNAL_TITLE_KEY);
        this.impressionUrls = json.impression_urls;
    }
}